import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import global from "./modules/global";
import user from "./modules/user";
import order from "./modules/order";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: "orderForm"
});

// FUPOF-191: a debounced draft auto-save plugin lived here and worked, but
// auto-save wasn't client-requested and is parked pending confirmation.
// See .claude/context/FUPOF-187/FUPOF-191/AUTO-SAVE-PARKED.md.

Vue.use(Vuex);

export default new Vuex.Store({
  state: undefined,
  mutations: {},
  actions: {},
  modules: {
    global,
    user,
    order
  },
  plugins: [vuexLocal.plugin]
});
